@let dataVal = visData();
@let metaVal = meta();
@let componentVal = component();
@let metricVal = metric();

@if (dataVal) {
  <reports-visualization-layout
    [editable]="availableActions().canEdit"
    [filtersOverflowHidden]="filtersOverflowHidden()"
  >
    @if (componentVal && metricVal) {
      <div slot="header">
        <reports-visualization-title
          [name]="componentVal.name"
          [description]="componentVal.description ?? undefined"
        />

        <ng-content />
      </div>
    }

    @if (showActions()) {
      <reports-visualization-actions
        slot="header-actions"
        [availableActions]="availableActions()"
        [fullscreenAvailable]="fullscreenAvailable()"
        [failed]="metaVal.failed"
        (action)="handleAction.emit($event)"
        (openFeatureGuard)="openFeatureGuard.emit()"
        class="tile-option gridster-item-content"
      />
    }

    <reports-visualization-loading-indicator
      [small]="componentVal?.grid?.rows === 1"
      [loading]="metaVal.loading"
      [loaded]="metaVal.loaded"
      [failed]="metaVal.failed"
    />

    @if (metricVal && componentVal) {
      <reports-visualization-renderer
        slot="renderer"
        [rtResizeObserver]="{ initial: false }"
        [resourcesPreviewAvailable]="metricVal.hasDetails"
        [loading]="metaVal.loading"
        [loaded]="metaVal.loaded"
        [failed]="metaVal.failed"
        [data]="dataVal"
        [component]="componentVal"
        [metric]="metricVal"
        [visualizationDisabled]="visualizationDisabled()"
        [allowRefreshing]="true"
        (refresh)="refresh.emit()"
        (tableSortChange)="updateSort.emit($event)"
        (editClick)="editComponent.emit()"
        (openDetails)="openDetails.emit($event)"
      />
    }
  </reports-visualization-layout>
}
